import * as React from 'react';
import { memo } from 'react';

const SvgPin = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none" }, props),
    React.createElement("path", { d: "M10.917 9.908v6.509H9.084V9.908A4.585 4.585 0 0 1 10 .833a4.583 4.583 0 0 1 .917 9.075Zm-3.667 2.07v1.858c-2.688.335-4.583 1.102-4.583 1.664 0 .74 3.28 1.834 7.333 1.834 4.053 0 7.334-1.094 7.334-1.834 0-.562-1.895-1.329-4.584-1.664v-1.858c3.718.407 6.417 1.66 6.417 3.522 0 2.298-4.107 3.667-9.167 3.667S.833 17.798.833 15.5c0-1.863 2.7-3.115 6.417-3.522Zm5.5-6.561a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0Z", fill: "#fff" })));
const Memo = memo(SvgPin);

export { Memo as default };
